import { Row, Col } from "react-bootstrap";
import "./category.css";
import { useState, useEffect, useRef } from "react";
import { getCategory } from "../../api/api";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useMediaQuery } from "react-responsive";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import {handleError} from "../../helpers/handleError";

const Category = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(true);
  const [category, setCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredIndex1, setHoveredIndex1] = useState(null);
  const [isDotActive, setIsDotActive] = useState(0);
  const [bullets, setBullets] = useState(0);
  const swiperRef = useRef(null);
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" });
  const navigate = useNavigate();
  // Create a reference to store swiper instance

  const handleFirstClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(swiperRef.current.activeIndex);
    }
  };

  const handleLastClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(swiperRef.current.activeIndex);
    }
  };

  const getcategory = async () => {
    try {
      setIsLoading(true)
      const response = await getCategory();
      if (response.status === 200) {
        setCategory(response.data.info);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1200);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    getcategory();
    AOS.init({
      disable: function () {
        return window.innerWidth < 600; // Disable AOS for screens smaller than 900px
      },
    });
  }, []);
  if (isLoading) return <SpinLoading />;

  return (
    <>
      <Row style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Col sm={12} md={12} lg={12} xl={12} className="category1">
          <span>CATEGORIAS POPULARES</span>
        </Col>
        <Col sm={12} md={12} lg={12} xl={12} className="category2">
          <span>¡Explora las mejores selecciones según diversos intereses y necesidades!</span>
        </Col>
      </Row>

      <Swiper
        className="category4"
        slidesPerView={6}
        slidesPerGroup={1}
        spaceBetween={20}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay]}
        breakpoints={{
          1200: {
            slidesPerGroup: 1,
            slidesPerView: 6,
            spaceBetween: 20,
          },
          768: {
            slidesPerGroup: 1,
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }}
      >
        {category.map((item, index) => (
                  <SwiperSlide
            className="category3"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            key={index}
            // data-aos="fade-up"
            // data-aos-delay={`${index * 100}`}
            onClick={() => {
              navigate(`/event`, { state: { categoryId: item.id } });
            }}
          >
            <div className="animated-div">
              <span className="animated-div-transition"></span>
              <span className="animated-div-label">
                <Row style={{ backgroundColor: "transparent" }}>
                  <img src={item.image} alt={item.name} className="category-image" />
                  <img src={item.hoverimage} alt={item.name} className="category-hoverimage" />
                </Row>
                <Row className="category-name">{item.name}</Row>
                <Row className="eventcount">
                  <span className="eventcountdesktop">
                    {hoveredIndex === index ? "Ver detalles" : item.event + " Eventos"}
                  </span>
                  <span className="eventcountmobile">{item.event + " Eventos"}</span>
                </Row>
              </span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* <Row className="category4">
        {category.slice(0, 4).map((item, index) => (
          <Col
            sm={3}
            md={3}
            lg={3}
            xl={2}
            className="category3"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            key={index}
            data-aos="fade-up"
            data-aos-delay={`${index * 100}`}
            onClick={() => {
              navigate(`/event`, { state: { categoryId: item.id } });
            }}
          >
            <div className="animated-div">
              <span className="animated-div-transition"></span>
              <span className="animated-div-label">
                <Row className="category-name">{item.name}</Row>
                <Row style={{ backgroundColor: "transparent" }}>
                  <img src={item.image} alt={item.name} className="category-image" />
                  <img src={item.hoverimage} alt={item.name} className="category-hoverimage" />
                </Row>
                <Row className="eventcount">
                  <span className="eventcountdesktop">
                    {hoveredIndex === index ? "View Detail" : item.event + " Eventss"}
                  </span>
                  <span className="eventcountmobile">{item.event + " Events"}</span>
                </Row>
              </span>
            </div>
          </Col>
        ))}

        
        {isTablet && (
          <>
            {category.slice(4, 6).map((item, index) => (
              <Col
                sm={3}
                md={3}
                lg={3}
                xl={2}
                className="category3"
                key={index}
                data-aos="fade-up"
                data-aos-delay={`${index == 0 ? 400 : 500}`}
                onClick={() => navigate(`/event`, { state: { categoryId: item.id } })}
              >
                <div
                  className="animated-div"
                  onMouseEnter={() => setHoveredIndex1(index)}
                  onMouseLeave={() => setHoveredIndex1(null)}
                >
                  <span className="animated-div-transition"></span>
                  <span className="animated-div-label">
                    <Row className="category-name">{item.name}</Row>
                    <Row style={{ backgroundColor: "transparent" }}>
                      <img src={item.image} alt={item.name} className="category-image" />
                      <img src={item.hoverimage} alt={item.name} className="category-hoverimage" />
                    </Row>
                    <Row className="eventcount">
                      <span>{hoveredIndex1 === index ? "View Detail" : item.event + " Events"}</span>
                    </Row>
                  </span>
                </div>
              </Col>
            ))}
          </>
        )}
      </Row> */}

      <div className="category5">
        <Swiper
          slidesPerView={2.3}
          spaceBetween={20}
          pagination={{ el: ".pagination-bullets-category", clickable: true }}
          navigation={{
            prevEl: ".arrow-category.first",
            nextEl: ".arrow-category.last",
          }}
          modules={[Pagination, Navigation]}
          className="mySwipers"
          onSwiper={(swiper) => {
            swiperRef.current = swiper; // Store swiper instance in useRef
          }}
          breakpoints={{
            768: {
              slidesPerView: 3.4,
              spaceBetween: 40,
            },
            320: {
              slidesPerView: 2.2,
              spaceBetween: 10,
            },
          }}
        >
          {category.map((item, index) => (
            <SwiperSlide
              className="category3"
              key={index}
              onClick={() => navigate(`/event`, { state: { categoryId: item.id } })}
            >
              <div className="animated-div">
                <span className="animated-div-transition"></span>
                <span className="animated-div-label">
                 {/* <Row className="category-name">
                    <img src={item.image} alt={item.name} />
                  </Row>*/}
                  <Row className="category-name">{item.name}</Row>
                  <Row className="eventcount">
                    <span>{item.event + " Eventos"}</span>
                  </Row>
                </span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-pagination-category">
          <button className="arrow-category first" onClick={handleFirstClick} style={{ marginRight: "5px" }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.219639 6.53021C-0.0732538 6.23732 -0.0732538 5.76244 0.219639 5.46955L4.71964 0.969548C5.01253 0.676655 5.48741 0.676655 5.7803 0.969548C6.07319 1.26244 6.07319 1.73732 5.7803 2.03021L2.56063 5.24988L11.25 5.24988C11.6642 5.24988 12 5.58566 12 5.99988C12 6.41409 11.6642 6.74988 11.25 6.74988L2.56063 6.74988L5.7803 9.96955C6.07319 10.2624 6.07319 10.7373 5.7803 11.0302C5.48741 11.3231 5.01253 11.3231 4.71964 11.0302L0.219639 6.53021Z"
                fill="#8F99A2"
              />
            </svg>
          </button>

          <div className="pagination-bullets-category"></div>

          <button className="arrow-category last" onClick={handleLastClick} style={{ marginLeft: "5px" }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232 6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335787 6.75 0 6.41421 0 6C0 5.58579 0.335787 5.25 0.75 5.25L9.43934 5.25L6.21967 2.03033C5.92678 1.73744 5.92678 1.26256 6.21967 0.96967C6.51256 0.676777 6.98744 0.676777 7.28033 0.96967L11.7803 5.46967Z"
                fill="#8F99A2"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default Category;
